/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'universal-cookie'
import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { getPubAbbr, getUserName, getUserRole } from '@revbox/helpers-fe'
import { cookiesKeyNames } from '@revbox/common-fe'
import { userProfileDropdownTranslates, userRoleTranslates } from '@revbox/localization'

import { logosModule } from '../../modules/logos'
import { useCookiesContext, isCookiesEnabled } from '../../contexts/CookiesContext'
import { getAllRoles } from '../../services/micro'
import { clearUser } from '../../features/user'
import { clearAdvertiser } from '../../features/advertiser'
import { useClickOutside } from '../../hooks/useClickOutside'
import SidebarMenu from './SidebarMenu'
import { safeParse } from '@helpers/json-helper'

const PUBLISHER = 'PUBLISHER'

const cookies = new Cookies()

export const Sidebar = () => {
    const dispatch = useDispatch()
    const { getAdvertiserId, getPublisherId, getSkinMode, removeCookiesProperty, getLanguageAbbr, getPathKey } = useCookiesContext()

    const [subRoles, setSubRoles] = useState([])
    const user = useSelector(state => state.user)
    const [scrollBarRef, setScrollBarRef] = useState(null)
    const publisherIdByAbbr = getPubAbbr()
    const [menuOpened, setMenuOpened] = useState(false)
    const [publisherId, setPublisherId] = useState(null)
    const [currentSkin, setCurrentSkin] = useState(null)
    const [storedAdvId, setStoredAdvId] = useState(null)
    const [siteLogo, setSiteLogo] = useState(null)
    const footerMenuRef = useRef(null)

    useEffect(() => {
        setSiteLogo(logosModule(publisherId, currentSkin))
    }, [publisherId, currentSkin])

    useEffect(() => {
        const pathKey = getPathKey()
        const publisherIdByCookies = getPublisherId()
        const advIdByLStorage = getAdvertiserId()
        const currentSkin = getSkinMode()
        const publisherId = publisherIdByAbbr || publisherIdByCookies
        setPublisherId(publisherId)
        setCurrentSkin(currentSkin)
        const tmpAdvId = !isNaN(Number(pathKey)) ? pathKey : undefined
        setStoredAdvId(advIdByLStorage || tmpAdvId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.pathname])

    // avaliable_accesses
    // "user_account_management_access"
    // "finance_access"
    // "dashboards_access"
    // "inventory_access"
    // "advertiser_access"
    // "customers_access"
    // "user_roles_management_access"
    // "global_variables_access"
    // "webhook_access"
    // "api_key_access"
    // "notifications_access"

    useEffect(() => {
        getAllRoles(storedAdvId)
            .then(res => {
                setSubRoles(res.data)
            })
            .catch(e => {
                console.log(e)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const toggleFooterMenu = () => {
        setMenuOpened(!menuOpened)
    }

    const toggleFooterMenuWithDelay = () => {
        setTimeout(() => {
            toggleFooterMenu()
        }, 400)
    }

    useClickOutside(footerMenuRef, toggleFooterMenu, menuOpened)

    const urlParams = new URLSearchParams(window.location.search)
    const advId = urlParams.get('advId')
    const pubId = urlParams.get('pub')

    const userAccesses = subRoles.find(subRole => subRole.name == user.role)?.avaliable_accesses
    const homePath = storedAdvId ? `/adv/home?advId=${advId}&pub=${pubId}` : `/pub/dashboard/revenue`
    const accountSettingsPath = storedAdvId ? `/adv/settings?advId=${advId}&pub=${pubId}` : `/pub/settings`
    const globalConfigurationsPath = storedAdvId ? `/pub/configurations` : '/pub/configurations'
    const automationsPath = storedAdvId ? `/adv/automations` : '/pub/automations'
    const automationsPermission =
        userAccesses &&
        (userAccesses.includes('api_key_access') || userAccesses.includes('webhook_access') || userAccesses.includes('ai_automations'))

    const globalConfigurationsPermission = userAccesses && userAccesses.includes('global_variables_access')

    let marginForSidebarFooter = 0

    const isCustomer = user.role === 'CUSTOMER'

    if (!automationsPermission) marginForSidebarFooter += 35
    if (!globalConfigurationsPermission) marginForSidebarFooter += 35
    if (!userAccesses?.includes('api_key_access')) marginForSidebarFooter += 35
    if (isCustomer) {
        if (menuOpened) marginForSidebarFooter -= 70
        else marginForSidebarFooter += 35
    }

    const handleLogout = () => {
        dispatch(clearUser())
        dispatch(clearAdvertiser())
        removeCookiesProperty(cookiesKeyNames.token)
        removeCookiesProperty(cookiesKeyNames.publisherId)
        removeCookiesProperty(cookiesKeyNames.advertiserId)
    }

    const language = getLanguageAbbr()
    const title = userProfileDropdownTranslates[language]

    const userRole = getUserRole(user)
    const translatedUserRole = userRoleTranslates[language][userRole]

    return (
        <div className={`sidebar ${menuOpened ? 'footer-menu-show' : ''}`}>
            <div className="sidebar-header">
                <Link to={homePath} className="sidebar-logo">
                    {/* <object type="image/svg+xml" data={siteLogo} className="w-100" aria-label="svg image"></object>  */}
                    {siteLogo}
                </Link>
            </div>
            <PerfectScrollbar
                className="sidebar-body"
                ref={ref => setScrollBarRef(ref)}
                options={{
                    wheelPropagation: false
                }}
            >
                {user && (
                    <SidebarMenu
                        onUpdateSize={() => scrollBarRef.updateScroll()}
                        userAccesses={userAccesses}
                        advertiserId={storedAdvId}
                        publisherId={publisherId}
                        user={user}
                    />
                )}
            </PerfectScrollbar>
            <div
                className="sidebar-footer"
                ref={footerMenuRef}
                style={{
                    marginBottom: user?.role !== PUBLISHER ? `${marginForSidebarFooter}px` : 0
                }}
            >
                <div className="sidebar-footer-top">
                    <div className="sidebar-footer-thumb avatar online">
                        <span className="avatar-initial bg-primary">{getUserName(user)[0]}</span>
                    </div>
                    <div className="sidebar-footer-body">
                        <h6>
                            <Link to={accountSettingsPath}>{getUserName(user)}</Link>
                        </h6>
                        <p>{translatedUserRole}</p>
                    </div>
                    <Button onClick={toggleFooterMenu} className="dropdown-link" style={{ backgroundColor: 'transparent', border: 'none' }}>
                        <i className={menuOpened ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'}></i>
                    </Button>
                </div>
                <div className="sidebar-footer-menu">
                    <nav className="nav">
                        {userAccesses && userAccesses.includes('api_key_access') && (
                            <Link onClick={toggleFooterMenuWithDelay} to="https://docs.revbox.co/docs/intro/?code=XrUo7zIhhU<" target="_blank">
                                <i className="ri-question-line"></i> {title.documantation}
                            </Link>
                        )}
                    </nav>
                    <hr />
                    <nav className="nav">
                        {/* <Link to="/adv/settings"><i className="ri-refund-line"></i> Revbox Billing</Link> */}
                        <Link to={accountSettingsPath} onClick={toggleFooterMenuWithDelay}>
                            <i className="ri-user-settings-line"></i> {title.accountSettings}
                        </Link>
                        {/* {
                            userAccesses && userAccesses.includes("customers_access") &&
                            <Link to="/pub/customer/campaign/new"><i className="ri-add-line"></i> New Campaign</Link>
                        } */}
                    </nav>
                    {globalConfigurationsPermission && !isCustomer && (
                        <nav className="nav">
                            <Link to={globalConfigurationsPath} onClick={toggleFooterMenuWithDelay}>
                                <i className="ri-settings-4-line"></i> {title.globalConfigurations}
                            </Link>
                        </nav>
                    )}

                    {automationsPermission && !isCustomer && (
                        <nav className="nav">
                            <Link to={automationsPath} onClick={toggleFooterMenuWithDelay}>
                                <i className="ri-code-s-slash-line"></i> {title.automations}
                            </Link>
                        </nav>
                    )}
                    <hr />
                    <nav className="nav">
                        <Link to={`/pages/signin?pub=${user.publisher_id}`} onClick={handleLogout}>
                            <i className="ri-logout-box-r-line"></i> {title.logout}
                        </Link>
                    </nav>
                </div>
            </div>
        </div>
    )
}

window.addEventListener('load', function () {
    let HTMLTag = document.querySelector('html')
    let skinMode = isCookiesEnabled
        ? cookies.get('pub')?.[cookiesKeyNames.skinMode]
        : safeParse(localStorage.getItem('pub') || '{}')[cookiesKeyNames.skinMode]

    if (skinMode) {
        HTMLTag.setAttribute('data-sidebar', skinMode)
    }
})
